import React from 'react';
import { metricGroupHistory, type SportMetricGroup } from '../data/sportMetrics';
import { useLocale } from '../contexts/LocaleContext';
import { formatMetricGroup } from '../utils/sportFields';

/**
 * A grouped sport record (e.g. Boxing: wins · losses · draws) shown as one line,
 * with its dated history snapshots. Never charted piecemeal.
 */
export function SportMetricGroupRow({
  group
}: {
  group: SportMetricGroup;
}) {
  const {
    t,
    tl,
    locale
  } = useLocale();
  const ids = group.members.map(member => member.id);
  const current = Object.fromEntries(group.members.map(member => [member.id, member.value]));
  const hasRecord = group.members.some(member => member.value > 0);
  const history = [...(metricGroupHistory[group.id] ?? [])].reverse();
  return <li className="border-b border-sand-line py-2 last:border-b-0" data-id="element-1459" data-mp="1mg0t9zioqwqe">
      <div className="flex min-h-[40px] items-center gap-2" data-id="element-1460" data-mp="18j44s4q1hrco">
        <span className="min-w-0 flex-1" data-id="element-1461" data-mp="1ckpdddvjjjh2">
          <span className="block text-[13.5px] font-medium text-deep" data-id="element-1462" data-mp="1cjebjjlnolsl">{tl(group.label)}</span>
          <span className="mt-[2px] block text-[11px] leading-snug text-muted" data-id="element-1463" data-mp="2o4fs2g7wckrz">
            {t('sport.group.hint')}
          </span>
        </span>
        <span className="bee-num shrink-0 text-right text-[13px] font-bold text-deep" data-id="element-1464" data-mp="2y3wtumk12eio">
          {hasRecord ? formatMetricGroup(ids, current, locale) : t('metrics.noRecord')}
        </span>
      </div>
      {history.length > 1 && <details className="mt-1" data-id="element-1465" data-mp="25gkh143o5l2k">
          <summary className="min-h-[32px] cursor-pointer text-[11.5px] font-medium text-deep" data-id="element-1466" data-mp="25dex039wd9dp">
            {t('sport.group.history')}
          </summary>
          <ul className="mt-1" data-id="element-1467" data-mp="2f6duybraac9z">
            {history.map(entry => <li key={entry.date} className="flex items-baseline justify-between gap-2 py-[3px] text-[11.5px] text-muted" data-id="element-1468" data-mp="2aevtlmlcm9oh">
                <span className="bee-num" data-id="element-1469" data-mp="1mmx7e7kd2twk">
                  {new Date(`${entry.date}T00:00:00`).toLocaleDateString(locale, {
              day: '2-digit',
              month: 'short',
              year: 'numeric'
            })}
                </span>
                <span className="bee-num text-right text-deep" data-id="element-1470" data-mp="2bdupt7yyhfp4">
                  {formatMetricGroup(ids, entry.values, locale)}
                </span>
              </li>)}
          </ul>
        </details>}
    </li>;
}